import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import Button from '@/components/Button';
import AuthDialogTitle from '@/components/CandidateAuth/AuthDialogTitles/AuthDialogTitle';
import AuthPageLayout from '@/components/CandidateAuth/AuthPageLayout';
import CircularLoadingIndicator from '@/components/CircularLoadingIndicator';
import Text from '@/components/Text';

const CandidateWrongZone = () => {
  const router = useRouter();
  const [countDown, setCountDown] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => setCountDown((prev) => prev - 1), 1000);
    const timeout = setTimeout(() => router.replace('/builder'), 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <AuthPageLayout className="bg-neutral-100">
      <AuthDialogTitle
        title="Wrong zone"
        subtitle="This area is for recruiters only. Your account does not have access here."
      />
      <div className="flex gap-3">
        <CircularLoadingIndicator />
        <Text className="text-neutral-1000 opacity-80">
          Redirecting to Builder in {countDown}
        </Text>
      </div>
      <Link href="/builder" className="w-full max-w-xl">
        <Button className="w-full" variant="jbPrimary">
          Go to Builder
        </Button>
      </Link>
    </AuthPageLayout>
  );
};

export default CandidateWrongZone;
